import {Typography, styled} from "@mui/material";

export const TypographySubTitle = styled(Typography)(({ theme, color}) => ({
  fontSize: 12,
  color: color ?? '#4F4F4F'
}));

export const TypographyMediumSize = styled(Typography)(({ theme, color}) => ({
  fontSize: 14,
  color: color ?? '#4F4F4F'
}));

export const TypographyBasic = styled(Typography)(({ theme, fw}) => ({
  fontSize: 16,
  fontWeight: fw ?? 300,
  color: 'black'
}));